<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/loader";
import axios from "axios";
import moment from "moment";
import "vue-select/dist/vue-select.css";
import Vuetable from "vuetable-2";
import {
  authMethods,
  authFackMethods,
  notificationMethods,
} from "@/state/helpers";
import { mapState } from "vuex";
import { authComputed } from "@/state/helpers";
// Lets Register a Global Error Notification Toast.

/**
 * Departamento component
 */
export default {
  page: {
    title: "Información de creditos",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, Loader, Vuetable },
  data() {
    return {
      apiUrl: process.env.VUE_APP_URL,
      userT: this.$store.state.authfack.user,
      httpOptions: {
        headers: { "x-token": this.$store.state.authfack.user.token },
      },
      stock: [],
      url: 0,
      detalleorden: [],
      fields: [
        {
          name: "metodo_pago",
          sortField: "metodo_pago",
          title: "Metodo de Pago",
          titleClass: "",
          dataClass: "list-item-heading",
          width: "20%",
        },
        {
          name: "numero_pago",
          sortField: "numero_pago",
          title: "Numero de Pago",
          titleClass: "",
          dataClass: "list-item-heading",
          width: "20%",
        },
        {
          name: "fechapago",
          sortField: "fechapago",
          title: "Fecha de pago",
          titleClass: "",
          dataClass: "list-item-heading",
          width: "15%",
        },
        {
          name: "abono",
          sortField: "abono",
          title: "Abono",
          titleClass: "",
          dataClass: "list-item-heading",
          width: "15%",
        },

        /*  {
          name: "saldo",
          sortField: "saldo",
          title: "Saldo",
          titleClass: "",
          dataClass: "list-item-heading",
          width: "20%",
        }, */
        {
          name: "estado",
          title: "Estado",
          titleClass: "",
          dataClass: "text-muted",
          width: "10%",
        },
      ],
      css: {
        table: {
          tableClass: "table table-striped table-bordered table-hovered",
          loadingClass: "loading",
          ascendingIcon: "glyphicon glyphicon-chevron-up",
          descendingIcon: "glyphicon glyphicon-chevron-down",
          handleIcon: "glyphicon glyphicon-menu-hamburger",
        },
      },
      formget: {
        nombre: "",
        state: true,
      },
      formSub: {
        nombre: "",
        cantidaddepa: "",
        state: true,
        id: 0,
      },
      updating: false,
      title: "Información",
      itemst: [
        {
          text: "Inventario",
          href: "/",
        },
        {
          text: "Información",
          active: true,
        },
      ],
      loadingtable: false,

      showModalL: false, //Loading
      showModalE: false, //Editar
      showModalN: false, //Nuevo registro
      showModalD: false, //Desactivar
      showModalA: false, //Activar
      data: [],
    };
  },
  mounted() {
    const usuario = this.$store.state.authfack.user;
    if (usuario == "" || usuario == null || usuario == "null") {
      this.logout();
      location.reload();
    } else {
      axios({
        baseURL: this.apiUrl + "auth/checkToken",
        method: "POST",
        headers: { "x-token": usuario.token },
      })
        .then((res) => {
          if (res.data.success) {
            // this.$router.push("/");
          }
        })
        .catch(() => {
          this.logout();
          location.reload();
        });
    }
    this.detalle();
  },
  watch: {},
  methods: {
    ...authMethods,
    ...authFackMethods,
    ...notificationMethods,
    // FUNCIONES AUXILIARES

    money(value) {
      return (
        "Q " +
        parseFloat(value)
          .toFixed(2)
          .replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
      );
    },
    showDate(date) {
      return moment(date).locale("es").utc().format("MMM Do YYYY");
    },
    detalle() {
      axios
        .get(
          process.env.VUE_APP_URL +
            "creditos/view_credito?id=" +
            this.$route.params.id,
          {
            headers: { "x-token": this.userT.token },
          }
        )
        .then((response) => {
          this.detalleorden = response.data;

          // console.log(response.data);
        });
    },
  },
  computed: {
    ...authComputed,
    ...mapState("authfack", ["status"]),
    /**
     * Total no. of records
     */
  },
};
</script>
<style>
/* Css para el loading en el modal */
.my-class {
  background: rgba(255, 255, 255, 0);
  color: white;
  border-bottom: 1px solid #f8f8f800;
  border: 1px solid #c02d2d00;
}
</style>
<template>
  <Layout>
    <PageHeader :title="title" :items="itemst" />

    <div class="row">
      <div class="col-12">
        <b-modal
          centered
          v-model="showModalL"
          title-class="text-black font-18"
          body-class="p-3"
          hide-footer
          no-close-on-backdrop
          content-class="my-class"
          header-class="my-class"
        >
          <template #modal-header="{}">
            <!-- Emulate built in modal header close button action -->

            <h5></h5>
          </template>
          <form>
            <div class="row">
              <div class="col-12">
                <div class="d-flex justify-content-center">
                  <fulfilling-bouncing-circle-spinner
                    :animation-duration="2000"
                    :size="90"
                    color="#2a3042"
                  />
                </div>
              </div>
            </div>
          </form>
        </b-modal>

        <!-- Modal para Activar -->

        <!-- Modal para Desactivar -->
        <!--             <b-modal
              centered
              v-model="showModalD"
              title="Desactivar"
              title-class="text-black font-18"
              body-class="p-3"
              hide-footer
                  >
                    <form>
                      <div class="row">
                        <div class="col-12">
                          <div class="mb-3">
                            
                         <h4>¿Desea Desactivar  {{this.formSub.nombre}}?</h4>
                            
                          </div>
                        </div>
                      
                       
                      </div>

                      <div class="text-end pt-5 mt-3">
                        <b-button variant="light" @click="showModalD = false">Cancelar</b-button>
                         <b-button variant="danger" @click="desactivate">Desactivar</b-button>
                      </div>
                    </form>
            </b-modal>
 -->

        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-sm-10">
                <h4 class="card-title">Listado de creditos</h4>
              </div>

              <div class="col-sm-2">
                <div>
                  <router-link
                    :to="{
                      name: 'credito',
                    }"
                  >
                    <b-button
                      variant="outline-primary"
                      type="button"
                      class="btn btn-rounded mb-2 me-2"
                    >
                      <i class="mdi mdi-arrow-collapse-left"></i> Regresar
                    </b-button>
                  </router-link>
                </div>
              </div>
            </div>
            <!-- Table -->
            <Loader :loading="loadingtable">
              <vuetable
                ref="vuetable"
                class="table-divided table-responsive order-with-arrow"
                :css="css.table"
                :api-mode="false"
                :fields="fields"
                :data="detalleorden"
              >
                <div slot="estado" slot-scope="props">
                  <h5 v-if="props.rowData.estado_credito == true">
                    <span class="badge bg-success ms-1"
                      ><strong>ACTIVO</strong></span
                    >
                  </h5>
                  <h5 v-else>
                    <span class="badge bg-danger ms-1"
                      ><strong>INACTIVO</strong></span
                    >
                  </h5>
                </div>
                <div slot="saldo" slot-scope="props">
                  {{ money(props.rowData.saldo) }}
                </div>
                <div slot="fechapago" slot-scope="props">
                  {{ showDate(props.rowData.fecha_pago) }}
                </div>
                <div slot="abono" slot-scope="props">
                  {{ money(props.rowData.abono) }}
                </div>
              </vuetable>
            </Loader>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>
